const groupBy = (arr, prop) =>
  Object.values(
    arr.reduce((acc, x) => {
      acc[x[prop]] = [...(acc[x[prop]] || []), x];
      return acc;
    }, {})
  );

export default { groupBy };
